import React from 'react';
import classNames from '../../../utility/classNames';
import CalculatedField from './CalculatedField';
import { checkCondition } from '../utility/filterSchema';
import { useFormikContext } from 'formik';

export default function CalculatedSection({ schema, data }) {
  if (!Array.isArray(schema) || !schema.length) return null;

  const { values } = useFormikContext();

  const schemaToUse = schema.filter((field) => {
    if (field?.condition) {
      return checkCondition(field.condition, { ...data, ...values });
    }
    return true;
  });

  return (
    <div
      className={classNames(
        'px-2 pt-3 pb-[14px] flex flex-col gap-3 w-full col-span-full items-center justify-center md:grid flex-wrap bg-[#EFF8F3] rounded-md',
        schemaToUse?.length === 1 && 'md:grid-cols-1',
        schemaToUse?.length === 2 && 'md:grid-cols-2',
        schemaToUse?.length === 3 && 'md:grid-cols-3',
        schemaToUse?.length === 4 && 'md:grid-cols-4'
      )}
    >
      {schemaToUse.map((field) => {
        return (
          <CalculatedField key={field.name} field={field} externalData={data} />
        );
      })}
    </div>
  );
}
